import { useEffect } from "react";

interface IPageDefaultProps extends React.HTMLProps<HTMLElement> {
  title?: string;
  breadcrumb?: boolean;
}

function PageDefault({ breadcrumb, title, children, ...props }: IPageDefaultProps ){
  useEffect(()=>{
    if(title)
    document.title = "SIM - "+title;
  },[title])

  return (
    <div className="pagedefault">
      {children}
    </div>
  );
}

export default Object.assign(PageDefault, {
  Title: require("./TitlePage").default,
  Content: require("./ContentPage").default,
  Nav: require("./NavPage").default,
  ContentMenu: require("./ContentPageMenu").default,
  Footer: require("./FooterPage").default,
});
export {default as TitlePage} from "./TitlePage";
export {default as ContentPage} from "./ContentPage";
export {default as NavPage} from "./NavPage";
export {default as ContentPageMenu} from "./ContentPageMenu";
export {default as FooterPage} from "./FooterPage";
export {default as ContentMenuItem} from "./ContentPageMenu/PageMenuItem";